import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, inject, provide } from 'intact-vue-next';
import template from './template.vdt';
import { LAYOUT, getStyle, BODY } from './helpers';
import { addStyle } from '../utils';
import { useConfigContext } from '../config';
import { makeBodyStyles } from './styles';
export var Body = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Body, _Component);
  function Body() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.layout = inject(LAYOUT);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Body.prototype;
  _proto.init = function init() {
    provide(BODY, this);
  };
  _proto.getClassNames = function getClassNames() {
    var _ref;
    var _this$get = this.get(),
      className = _this$get.className;
    var k = this.config.k;
    return _ref = {}, _ref[k + "-layout-body"] = true, _ref[className] = className, _ref[makeBodyStyles(k)] = true, _ref;
  };
  _proto.getStyles = function getStyles() {
    var style = this.get('style');
    var _this$layout$parse = this.layout.parse(),
      hasFixedAside = _this$layout$parse.hasFixedAside,
      asideWidth = _this$layout$parse.asideWidth,
      hasFixedHeader = _this$layout$parse.hasFixedHeader,
      headerHeight = _this$layout$parse.headerHeight;
    if (!hasFixedAside && !hasFixedHeader) return style;
    return addStyle(style, {
      // FIXME: we must use padding instead of margin, otherwise the table's width is wired
      paddingLeft: hasFixedAside ? getStyle(asideWidth) : null,
      marginTop: hasFixedHeader ? getStyle(headerHeight) : null
    });
  };
  return Body;
}(Component);
Body.template = template;